import { Button } from 'components/buttons/Button/Button';
import charts from 'images/charts.png';
import './styles.scss';
import GradientText from 'components/GradientText';

const TrialResults = () => {
    return (
        <section className="container">
            <div className="trial-results">
                <GradientText size="middle" textColor="white">
                    Discover our <em>trial results</em> & <em>crop nutrition programs</em>
                </GradientText>
                <div className="trial-results__inner-container">
                    <div className="trial-results__content">
                        <div className="trial-results__up">
                            <img src={charts} alt="charts" />
                        </div>
                        <div className="trial-results__down">
                            <h4>Trial results</h4>
                            <p className="body1">
                                Here you can find our trial results and
                                <br />
                                conclusions on the effectiveness of our
                                <br /> products in increasing yields.
                            </p>
                            <Button type="learn-more-arrow" />
                        </div>
                    </div>
                    <div className="crop-nutrition">
                        <div>
                            <h4>Crop nutrition programs</h4>
                            <p className="body1">
                                Learn how to care for your plants, providing them with proper nutrition for maximum crop
                                yield and health.
                            </p>
                            <Button type="learn-more-arrow" />
                        </div>
                    </div>
                    <div className="information-materials">
                        <h4>Information materials</h4>
                        <p className="body1">
                            Check out our product catalogs, which contain detailed information on composition and
                            application in PDF format.
                        </p>
                        <Button type="learn-more-arrow" />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default TrialResults;
